const isInteractiveDialog = (e: KeyboardEvent) => {
  const target = (e.target ?? {}) as HTMLElement;
  const ELEMENT_ROLES_TO_IGNORE = [
    "alertdialog",
    "dialog",
    "menu",
    "menuitem",
    "menuitemcheckbox",
    "menuitemradio",
    "option",
  ] as const;
  type ElementRolesToIgnore = (typeof ELEMENT_ROLES_TO_IGNORE)[number];

  if (
    ELEMENT_ROLES_TO_IGNORE.includes(
      target.getAttribute("role") as ElementRolesToIgnore,
    ) ||
    target.closest("*[role=dialog]") !== null ||
    target.querySelector("*[role=dialog]") !== null ||
    target.closest("*[role=alertdialog]") !== null ||
    target.querySelector("*[role=alertdialog]") !== null
  )
    return true;

  return false;
};

export { isInteractiveDialog };
